import * as React from 'react';
const FollicoliteDaDepilazioneIcon = ({
  primaryColor,
  secondaryColor,
  width,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M109.37 57.37c4.79 5.63 13.24 6.18 19.54 10.05 4.54 2.78 7.89 7.34 9.52 12.4 1.63 5.07 1.59 10.61.21 15.75 3.8 9.3 4.91 20.22 3.36 30.14M127.57 115.32c1.19 3.88 2.71 7.66 4.55 11.28"
      className="prefix__cls-2"
    />
    <path
      d="M125.05 142.63s-3.95-21.51 0-35.15c0 0 6.85-19.62-3.21-30.36M78.16 77.12c-10.06 10.75-3.21 30.36-3.21 30.36 3.95 13.65 0 35.15 0 35.15"
      className="prefix__cls-2"
    />
    <path
      d="M90.63 57.37C85.84 63 77.39 63.55 71.09 67.42c-4.54 2.78-7.89 7.34-9.52 12.4-1.63 5.07-1.59 10.61-.21 15.75-3.8 9.3-4.91 20.22-3.36 30.14M72.28 115.83c-1.16 3.7-2.63 7.31-4.4 10.77M79.65 103.36c5.29 1.61 11.23.96 16.05-1.76M119.81 103.36c-5.29 1.61-11.23.96-16.05-1.76M100 111.8v27.41M105.24 117.26c2.33.85 4.98.79 7.27-.15M105.24 124.24c2.33.85 4.98.79 7.27-.15M105.24 131.21c2.33.85 4.98.79 7.27-.15M94.91 117.26c-2.33.85-4.98.79-7.27-.15M94.91 124.24c-2.33.85-4.98.79-7.27-.15M94.91 131.21c-2.33.85-4.98.79-7.27-.15"
      className="prefix__cls-2"
    />
    <path
      d="M89.38 77.05c-.04.07-.01.17.06.2.07.04.17.01.2-.06.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06M109.24 74.25c-.04.07-.01.17.06.2.07.04.17.01.2-.06.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06M92.14 84.32c-.04.07-.01.17.06.2.07.04.17.01.2-.06.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06M84.88 89.01c-.04.07-.01.17.06.2.07.04.17.01.2-.06.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06M99.87 79.08c-.04.07-.01.17.06.2.07.04.17.01.2-.06.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06M102.66 89.01c-.04.07-.01.17.06.2.07.04.17.01.2-.06.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06M110.51 84.01c-.04.07-.01.17.06.2.07.04.17.01.2-.06.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06M116.82 88.86c-.04.07-.01.17.06.2.07.04.17.01.2-.06.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06"
      className="prefix__cls-1"
    />
  </svg>
);
export default FollicoliteDaDepilazioneIcon;
